/* src/app/modules/subscription/payment-history-dialog/payment-history-dialog.component.css */
.payment-history-dialog {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 80vh;
  font-family:
    "Inter Tight",
    Tahoma,
    Geneva,
    Verdana,
    sans-serif;
}
.pagination-controls {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  padding: 16px 0 4px;
}
.page-btn {
  border: 1px solid var(--cf-brand-dark);
  background: #ffffff;
  color: var(--cf-brand-dark);
  border-radius: 6px;
  padding: 6px 14px;
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
}
.page-btn:hover:not(:disabled) {
  background: #fff3e0;
}
.page-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.page-info {
  font-size: 13px;
  color: #666;
}
.dialog-header {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f5f5f5;
}
.dialog-header h2 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}
.dialog-content {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}
.table-container {
  width: 100%;
  overflow-x: auto;
}
.payment-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.payment-table thead {
  background-color: #f9f9f9;
  border-bottom: 2px solid #e0e0e0;
}
.payment-table th {
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #333;
}
.payment-table tbody tr {
  border-bottom: 1px solid #e0e0e0;
  transition: background-color 0.2s;
}
.payment-table tbody tr:hover {
  background-color: #f9f9f9;
}
.payment-table td {
  padding: 12px;
}
.invoice-number {
  font-weight: 500;
  color: var(--cf-brand-dark);
}
.invoice-date {
  color: #666;
}
.invoice-amount {
  font-weight: 600;
  color: #333;
}
.invoice-status {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}
.status-paid {
  background-color: #e8f5e9;
  color: #2e7d32;
}
.status-open {
  background-color: #fff3e0;
  color: #e65100;
}
.status-draft {
  background-color: #eceff1;
  color: #455a64;
}
.status-uncollectible {
  background-color: #ffebee;
  color: #c62828;
}
.status-void {
  background-color: #f3e5f5;
  color: #6a1b9a;
}
.download-button {
  color: var(--cf-brand-dark);
  padding: 0;
}
.download-button:hover {
  color: #b8790a;
}
.download-button mat-icon {
  margin-right: 4px;
  font-size: 18px;
  height: 18px;
  width: 18px;
}
.no-action {
  color: #ccc;
}
.no-payments {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #999;
}
.no-payments mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
  margin-bottom: 16px;
  opacity: 0.5;
}
.no-payments p {
  margin: 0;
  font-size: 16px;
}
.dialog-footer {
  padding: 20px;
  border-top: 1px solid #e0e0e0;
  background-color: #f5f5f5;
  display: flex;
  justify-content: flex-end;
}
.btn-factuone {
  min-width: 120px;
  border: 1px solid var(--cf-brand-dark);
  background: var(--cf-brand-dark);
  color: #ffffff;
  border-radius: 8px;
  padding: 9px 18px;
  font-weight: 700;
  cursor: pointer;
}
.btn-factuone:hover {
  border-color: var(--cf-brand-dark);
  background: var(--cf-brand-dark);
}
/*# sourceMappingURL=payment-history-dialog.component.css.map */
